<template>
  <div class="receive-record-dialog">
    <el-dialog 
      title="签收记录"
      v-model="dialogVisible" 
      width="1000px"
      @open="fetchReceiveRecords"
    >
      <el-table 
        :data="receiveRecords" 
        style="width: 100%" 
        border
        :loading="loading"
      >
        <el-table-column 
          prop="warehouseName" 
          label="签收仓库" 
          min-width="200"
        />
        <el-table-column 
          prop="quantity" 
          label="签收数量"
          min-width="150"
        />
        <el-table-column 
          prop="remark" 
          label="备注"
          min-width="200"
        >
          <template #default="scope">
              <div>签收备注：{{ scope.row.remark }}</div>
              <div>核实备注：{{ scope.row.checkRemarks }}</div>
          </template>
        </el-table-column>
        <el-table-column 
          prop="operationPerson" 
          label="签收人"
          min-width="150"
        />
        <el-table-column
            prop="CreateTime"
            label="签收时间"
            min-width="150"
        />
      </el-table>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElDialog, ElTable, ElTableColumn, ElButton } from 'element-plus'
import {getSignInfo} from "@/utils/api"
export default {
  name: 'ReceiveRecordDialog',
  components: {
    ElDialog,
    ElTable,
    ElTableColumn,
    ElButton
  },
  data() {
    return {
      dialogVisible: false,
      title:"",
      sku: "",
      formType:0,
      receiveRecords: [],
      loading: false
    }
  },
  methods: {
    fetchReceiveRecords() {
      this.loading = true
      // 模拟获取签收记录数据
      getSignInfo({fromType: this.formType, platformOrderId: this.title,materSku:this.sku}).then(res=>{
          this.receiveRecords = res.Data
          this.loading = false
      }).catch(err=>{
        this.loading = false
        console.log(err)
      })
    },
    open(data, formType) {
      this.dialogVisible = true
      this.formType = formType
      this.sku = data.stockSku
      this.title = data.recordId
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.receive-record-dialog {
  font-size: 14px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
